import { Unit, BaseUnits } from "uom";
/**
 * The derived unit for Celsius temperature ( <code>℃</code> ).
 * This is a unit of temperature such as the freezing point of water (at one atmosphere of pressure)
 * is 0 ℃, while the boiling point is 100 ℃.
 */
export var Celsius = Unit.plus("Celsius", 273.15, BaseUnits.Kelvin);
export var Rankine = Unit.divideNumber("Rankine", 9.0, Unit.timesNumber("", 5.0, BaseUnits.Kelvin));
export var Fahrenheit = Unit.plus("Fahrenheit", 459.67, Unit.divideNumber("", 9.0, Unit.timesNumber("", 5.0, BaseUnits.Kelvin)));
//# sourceMappingURL=temperature.js.map